import React, { useState, useEffect } from 'react';
import api from '../api/http';

const AnnualPlanForm = ({ onSubmit, initialData, refreshPlans }) => {
  const [formData, setFormData] = useState({
    sequence: '',
    audience: '',
    content: '',
    method: '',
    time: '',
    hours: '',
    participants: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (initialData) {
      setFormData({
        sequence: initialData.sequence || '',
        audience: initialData.audience || '',
        content: initialData.content || '',
        method: initialData.method || '',
        time: initialData.time || '',
        hours: initialData.hours || '',
        participants: initialData.participants || '',
      });
    }
  }, [initialData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    // 校验必填
    if (!formData.sequence || !formData.audience || !formData.content) {
      setError('请填写序号、培训人员和培训内容');
      setLoading(false);
      return;
    }
    try {
      const res = await api.post('/training_plans', formData);
      const result = res.data;
      console.log('后端返回:', result);
      if (result.success) {
        setFormData({
          sequence: '', audience: '', content: '', method: '', time: '', hours: '', participants: ''
        });
        if (onSubmit) onSubmit(result);
        if (refreshPlans) refreshPlans(); // 新增：保存成功后刷新列表
      } else {
        setError(result.message || '保存失败');
      }
    } catch (err) {
      setError('服务器错误');
    }
    setLoading(false);
  };

  // --- Styles ---
  const formGroupStyle = {
    marginBottom: '18px',
  };
  const labelStyle = {
    display: 'block',
    marginBottom: '6px',
    fontWeight: 500,
    fontSize: '14px',
    color: 'var(--text-primary)',
  };
  const inputStyle = {
    width: '100%',
    padding: '10px 12px',
    border: '1px solid var(--border-color)',
    borderRadius: '6px',
    background: 'var(--bg-primary)',
    color: 'var(--text-primary)',
    fontSize: '14px',
    boxSizing: 'border-box',
  };
  const textareaStyle = {
    ...inputStyle,
    minHeight: '100px',
    resize: 'vertical',
  };
  const buttonContainerStyle = {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '25px',
  };
  const submitButtonStyle = {
    padding: '10px 20px',
    border: 'none',
    borderRadius: '6px',
    background: 'var(--brand-primary)',
    color: 'white',
    fontSize: '14px',
    fontWeight: 600,
    cursor: 'pointer',
  };

  return (
    <form onSubmit={handleSubmit}>
      <div style={formGroupStyle}>
        <label htmlFor="sequence" style={labelStyle}>序号</label>
        <input
          type="number"
          id="sequence"
          name="sequence"
          value={formData.sequence}
          onChange={handleChange}
          style={inputStyle}
          required
        />
      </div>
      <div style={formGroupStyle}>
        <label htmlFor="audience" style={labelStyle}>培训人员</label>
        <input
          type="text"
          id="audience"
          name="audience"
          value={formData.audience}
          onChange={handleChange}
          style={inputStyle}
          required
        />
      </div>
      <div style={formGroupStyle}>
        <label htmlFor="content" style={labelStyle}>培训内容</label>
        <textarea
          id="content"
          name="content"
          value={formData.content}
          onChange={handleChange}
          style={textareaStyle}
          required
        />
      </div>
      <div style={formGroupStyle}>
        <label htmlFor="method" style={labelStyle}>培训方式</label>
        <input
          type="text"
          id="method"
          name="method"
          value={formData.method}
          onChange={handleChange}
          style={inputStyle}
        />
      </div>
      <div style={formGroupStyle}>
        <label htmlFor="time" style={labelStyle}>培训时间</label>
        <input
          type="text"
          id="time"
          name="time"
          value={formData.time}
          onChange={handleChange}
          style={inputStyle}
        />
      </div>
      <div style={formGroupStyle}>
        <label htmlFor="hours" style={labelStyle}>学时</label>
        <input
          type="number"
          id="hours"
          name="hours"
          value={formData.hours}
          onChange={handleChange}
          style={inputStyle}
        />
      </div>
      <div style={formGroupStyle}>
        <label htmlFor="participants" style={labelStyle}>参培对象</label>
        <input
          type="text"
          id="participants"
          name="participants"
          value={formData.participants}
          onChange={handleChange}
          style={inputStyle}
        />
      </div>
      {error && <div style={{ color: 'red', marginBottom: 10 }}>{error}</div>}
      <div style={buttonContainerStyle}>
        <button type="submit" style={submitButtonStyle} disabled={loading}>
          {loading ? '保存中...' : (initialData ? '更新计划' : '保存计划')}
        </button>
      </div>
    </form>
  );
};

export default AnnualPlanForm;
